/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type CreateDeliverableContainerReceiptActionMutationVariablesGQLType = Types.Exact<{
  userId: Types.Scalars['UUID'];
  organizationId: Types.Scalars['UUID'];
  receiptId: Types.Scalars['UUID'];
  action: Types.ReceiptActionTypePostCreationGQLType;
  commentId?: Types.Maybe<Types.Scalars['UUID']>;
}>;


export type CreateDeliverableContainerReceiptActionMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<Types.MutationGQLType, 'deliverableContainerReceiptAction'>
);


export const CreateDeliverableContainerReceiptActionDocumentGQLType = gql`
    mutation CreateDeliverableContainerReceiptAction($userId: UUID!, $organizationId: UUID!, $receiptId: UUID!, $action: ReceiptActionTypePostCreation!, $commentId: UUID) {
  deliverableContainerReceiptAction(
    userId: $userId
    organizationId: $organizationId
    receiptId: $receiptId
    action: $action
    commentId: $commentId
  )
}
    `;
export type CreateDeliverableContainerReceiptActionMutationFnGQLType = Apollo.MutationFunction<CreateDeliverableContainerReceiptActionMutationGQLType, CreateDeliverableContainerReceiptActionMutationVariablesGQLType>;

/**
 * __useCreateDeliverableContainerReceiptActionMutation__
 *
 * To run a mutation, you first call `useCreateDeliverableContainerReceiptActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeliverableContainerReceiptActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeliverableContainerReceiptActionMutation, { data, loading, error }] = useCreateDeliverableContainerReceiptActionMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      organizationId: // value for 'organizationId'
 *      receiptId: // value for 'receiptId'
 *      action: // value for 'action'
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useCreateDeliverableContainerReceiptActionMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeliverableContainerReceiptActionMutationGQLType, CreateDeliverableContainerReceiptActionMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeliverableContainerReceiptActionMutationGQLType, CreateDeliverableContainerReceiptActionMutationVariablesGQLType>(CreateDeliverableContainerReceiptActionDocumentGQLType, options);
      }
export type CreateDeliverableContainerReceiptActionMutationHookResult = ReturnType<typeof useCreateDeliverableContainerReceiptActionMutation>;
export type CreateDeliverableContainerReceiptActionMutationResultGQLType = Apollo.MutationResult<CreateDeliverableContainerReceiptActionMutationGQLType>;
export type CreateDeliverableContainerReceiptActionMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateDeliverableContainerReceiptActionMutationGQLType, CreateDeliverableContainerReceiptActionMutationVariablesGQLType>;